import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { PortalJourneyListRow } from "./types";

// GET /api/portal/journeys/list — every journey assignment for the calling
// partner, sorted by assigned_at desc. Filtering by segment (active /
// completed) is client-side; the dataset is small and stays fresh in
// cache.

export function useJourneyInstancesList() {
  return useQuery<PortalJourneyListRow[]>({
    queryKey: queryKeys.portal.journeys.list(),
    queryFn: () => apiFetch<PortalJourneyListRow[]>("/portal/journeys/list"),
  });
}
